import { useSelector } from 'react-redux'
import LogInPage from '../auth/LogIn/LogInPage'
import FourOhFour from '../common/FourOhFour'
import ProShopDisplay from './ProShopDisplay'

const ProShopPage = () => {
  const user = useSelector(state => state.user.current_user)
  const isCoach = user.type === 'Coach'

  if (!isCoach) {
    return <FourOhFour />
  }

  if (!user.user_settings) {
    return <LogInPage />
  }

  return <ProShopDisplay />
}

export default ProShopPage
